import { useTranslation } from 'react-i18next'
import { LandingFrame } from '../features/landing/ui/LandingFrame'
import { LandingDetailHero } from '../features/landing/ui/LandingDetailHero'
import { PricingSection } from '../features/landing/ui/PricingSection'

export function LandingPricingPage() {
  const { t } = useTranslation()

  return (
    <LandingFrame>
      <LandingDetailHero
        badge={t('landing.pages.pricing.badge')}
        title={t('landing.pages.pricing.title')}
        subtitle={t('landing.pages.pricing.subtitle')}
        highlights={[
          t('landing.pages.pricing.highlights.1'),
          t('landing.pages.pricing.highlights.2'),
          t('landing.pages.pricing.highlights.3'),
        ]}
        visual={
          <div className="rounded-2xl border border-border/70 bg-card/80 p-5 shadow-[0_0_32px_var(--glow-brand)] backdrop-blur">
            <div className="mb-3 text-xs text-muted-foreground">
              {t('landing.pages.pricing.visualTitle')}
            </div>
            <div className="space-y-3">
              {[1, 2, 3].map((item) => (
                <div
                  key={item}
                  className="rounded-xl border border-border/70 bg-background/65 p-3"
                >
                  <div className="text-sm font-medium text-foreground">
                    {t(`landing.pages.pricing.visualCards.${item}.title`)}
                  </div>
                  <div className="mt-1 text-xs text-muted-foreground">
                    {t(`landing.pages.pricing.visualCards.${item}.description`)}
                  </div>
                </div>
              ))}
            </div>
          </div>
        }
      />
      <PricingSection />
    </LandingFrame>
  )
}
